import { FC } from 'react';

import { Box, css, styled, Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import Image from 'next/image';
import checkmarkIcon from 'public/icons/checkmark-icon-green.svg';
import { components, OptionProps } from 'react-select';

import { LanguageOption } from './locale-picker.types';

export const LocalePickerOption: FC<OptionProps<LanguageOption, false>> = ({
  children,
  ...props
}) => {
  const { palette } = useTheme();
  const { data } = props;
  const { icon, label } = data;

  return (
    <components.Option {...props}>
      <StyledOption
        component="div"
        variant="body1"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={4}
        color={palette.text.primary}
      >
        <Box display="flex" alignItems="center">
          <Box width={12} mr={2} pt={1}>
            {props.isSelected && <Image src={checkmarkIcon} alt="selected-option" />}
          </Box>
          <Typography color={props.isSelected ? palette.primary.main : palette.text.primary}>
            {children}
          </Typography>
        </Box>
        <Image src={icon} alt={label} />
      </StyledOption>
    </components.Option>
  );
};

const StyledOption = styled(Typography)(
  ({ theme }) => css`
    &:hover {
      background-color: ${theme.palette.primary.main};
      color: ${theme.palette.common.white};
    }
  `
) as typeof Typography; //Complications with the component prop - https://mui.com/material-ui/guides/typescript/#complications-with-the-component-prop
